import React, { useMemo } from "react";
import { Modal, Table } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { getStoreColumns } from "./columns";
import {
  getStoreModalTitle,
  normalizeStoreRows,
} from "./utils/storeMetrics";
import classes from "./StoreEventModal.module.scss";

const StoreEventModal = ({ event, open, onClose }) => {
  const storeRows = useMemo(
    () => normalizeStoreRows(event?.originalEvent?.metrics),
    [event]
  );
  const storeSummary = useMemo(
    () => ({
      participants: event?.participants || "-",
      period:
        event?.startDate && event?.endDate
          ? `${event.startDate} - ${event.endDate}`
          : "-",
    }),
    [event]
  );
  const columns = useMemo(() => getStoreColumns(storeRows), [storeRows]);
  const title = getStoreModalTitle(event);

  return (
    <Modal
      className={classes.StoreModal}
      closeIcon={<CloseOutlined className={classes.CloseIcon} />}
      footer={null}
      onCancel={onClose}
      open={open}
      width={856}
    >
      <div className={classes.ModalHeader}>
        <h2 className={classes.Title}>{title}</h2>
      </div>

      <div className={classes.ModalContent}>
        <div className={classes.SummaryRow}>
          <span className={classes.SummaryItem}>
            Participantes:
            <strong>{storeSummary.participants}</strong>
          </span>
          <span className={classes.Period}>{storeSummary.period}</span>
        </div>

        <Table
          className={classes.StoreTable}
          columns={columns}
          dataSource={storeRows}
          locale={{ emptyText: "Nenhum dado encontrado." }}
          pagination={false}
          rowKey="id"
          tableLayout="fixed"
        />
      </div>
    </Modal>
  );
};

export default StoreEventModal;
